module.exports = __webpack_public_path__ + "cf045717ac40f7f2bec7d155703dec37.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/logos/plant.svg
 ** module id = 435
 ** module chunks = 0
 **/